import React from "react";
import { StreamProvider } from "@teamrota/shiftstreamlib";
import { cleanAddress, getProviderLabel, hasExternalSystem } from "../../utils";

export const Provider = ({ account }: { account: any }) => {
  const isEmailProvider = account.provider === StreamProvider.EMAIL;
  const hasExternalLink = hasExternalSystem(account.provider);

  const name =
    hasExternalLink ? (
      <>
        <a href={account.url} target="_blank" rel="noreferrer">
          {getProviderLabel(account.provider)} - {account.name}
        </a>
      </>
    ) : (
      <>
        {getProviderLabel(account.provider)} - {account.name}
      </>
    );

  return (
    <>
      <img
        title={account.name}
        src={`/images/shiftstream/${account.provider}.png`}
        alt={`${account.provider} logo`}
        style={{ height: 30, marginRight: 10, verticalAlign: "middle" }}
      />
      <div style={{ display: "inline-block", verticalAlign: "middle" }}>
        <div>{name}</div>

        <div style={{ fontSize: "70%" }}>
          {isEmailProvider ? (
            <>
              Email:{" "}
              <span style={{ fontWeight: "bold" }}>
                {cleanAddress(account.url)}
              </span>
            </>
          ) : hasExternalLink ? (
            <>
              Login: <span style={{ fontWeight: "bold" }}>{account.login}</span>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};
